import {Rules} from "./Rules";
import {ValidatorProvider} from "./ValidatorContext";
import _ from "lodash";

export const check = function (data, rule, options, setErrorMessage) {
  if (!Rules.hasOwnProperty(rule)) {
    return true;
  }

  if (!data && !(rule === "required")) {
    return true
  } else if (!data) {
    return false
  }


  if (options !== null) {
    return Rules[rule](data, options, setErrorMessage);
  } else {
    return Rules[rule](data, setErrorMessage);
  }
};

export const checkAll = function () {
  let isValidate = true;
  const validators = ValidatorProvider.getValidatorComponents();
  for (let i = 0; i < validators.length; i++) {
    if (!isValidate) {
      break
    }
    if (!validators[i]["rules"].includes("|")) {
      const ruleParts = _.split(validators[i]["rules"], "=");
      const ruleName = ruleParts[0];
      const ruleOptions = ruleParts[1] || null;
      isValidate = check(validators[i]["state"], ruleName, ruleOptions);
      if (!isValidate) {
        break;
      }
    } else {
      const split_validator = validators[i]["rules"].split("|");
      for (let j = 0; j < split_validator.length; j++) {
        const ruleParts = _.split(split_validator[j], "=");
        const ruleName = ruleParts[0];
        const ruleOptions = ruleParts[1] || null;
        isValidate = check(validators[i]["state"], ruleName, ruleOptions);
        if (!isValidate) {
          break;
        }
      }
    }
  }
  return isValidate;
};